const branding = {
    primary: '#e12726',
    primaryDark: '#b52025',
    secondary: '#444',
    secondaryDark: '#333',
    accent: '#214e75',
    accentDark: '#1a3b5a',
};

const defaults = {

    background: {
        main: '#fff',
        banner: branding.secondary,
        bannerHover: '#ffffff0a',
        bannerActive: '#ffffff14',
        panel: '#f4f4f4',
        listRow: {
            normal: '#fff',
            hover: '#f5f7fa',
        },
        menuItemHover: '#f5f5f5',
        modalScrim: '#0f141e73',
        hoverOverlayOnDark: '#ffffff2e',
        button: {
            primary: {
                normal: branding.primary,
                hover: branding.primaryDark,
            },
            secondary: {
                normal: '#efefef',
                hover: '#dcdcdc',
            },
            normal: branding.primary,
            hover: branding.primaryDark,
        },
        link: {
            hover: branding.primary,
        },
        spacer: branding.secondaryDark
    },
    border: {
        main: {
            highlight: '#5b5b5b',
            shadow: '#2b2b2b',
        },
        panel: {
            highlight: '#888',
            shadow: '#444',
        },
        primary: {
            highlight: branding.primary,
            shadow: branding.primaryDark,
        },
        button: '#888',
        rowDivider: '#ececec',
        dropdown: '#e0e0e0',
        dropdownDivider: '#f0f0f0',
        bannerDivider: '#ffffff33',
        menu: '#e8e8e8',
        footer: '#b2b2b2',
        spinner: {
            highlight: '#f3f3f3',
            shadow: '#2b2b2b',
        },
    },
    icon: {
        success: '#40d040',
        error: '#d02e2e',
        warning: '#ecc42e',
        default: '#2e43d0',
    },
    font: {
        main: '#000',
        bodyStrong: '#1a1a1a',
        bodyMuted: '#5a5a5a',
        subtle: '#666',
        emphasis: '#444',
        title: {
            default: branding.primary
        },
        link: branding.accent,
        linkHover: branding.accentDark,
        contrast: '#fff',
        button: '#9c3d3d',
        success: '#4caf50',
        active: '#bdc5cd',
        error: '#ff0000',
        overdue: '#ff7c00',
        disabled: '#888',
        modified: '#ffcc00',
        messageIcon: {
            success: '#fff',
            error: '#fff',
            warning: '#000',
            default: '#fff',
        }
    },
    shadow: {
        drawer: '2px 0 18px #0000002e, 1px 0 0 #0000000a',
        dropdown: '0 6px 20px #0000001f',
        menu: '0 8px 24px #0000001f, 0 2px 6px #0000000f',
        card: '0 3px 6px 0 #0000001a',
    },
};

export default defaults;